<div class=" bg-[#F5F7FA]  h-[72px] p-[24px] shadow-xs  py-2">
  <!-- Remplacez le contenu du breadcrumb statique par le composant dynamique -->
  <app-breadcrumb></app-breadcrumb>
  
  <!-- Tab navigation peut rester ici si nécessaire -->
  <div class="container mx-auto px-4">
    <!-- Le contenu des onglets peut être conservé ici si nécessaire -->
  </div>
</div>